/**
 * @license
 * Copyright 2024 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * This file contains all labels for AdditionalInformationComponent
 * used to collect information about the usage of EE4E internal instance.
 */

/** The title of Additional Information Component. */
export const ADDITIONAL_INFORMATION_TITLE = 'General Information';
/** The label of field1 of Additional Information Component. */
export const ADDITIONAL_INFORMATION_LABEL_FIELD1 = 'Customer Name';
/** The label of field2 of Additional Information Component. */
export const ADDITIONAL_INFORMATION_LABEL_FIELD2 = 'Connect Sales Customer ID';
/** The label of field1 of Additional Information Component. */
export const ADDITIONAL_INFORMATION_LABEL_FIELD3 = 'Estimated Revenue Impact';
